import { Model, belongsTo, hasMany } from 'miragejs';

export default Model.extend({
  cmsCreatorId: belongsTo('user', { inverse: null }),
  cmsLockerId: belongsTo('user', { inverse: null }),
  cmsModifierId: belongsTo('user', { inverse: null }),
  cmsOwnerId: belongsTo('user', { inverse: null }),
  country: belongsTo('category', { inverse: null }),
  link: belongsTo('link', { inverse: null }),
  partnerType: belongsTo('category', { inverse: null }),
  region: belongsTo('category', { inverse: null }),
  tradeTypes: hasMany('category', { inverse: null }),
});
